import { render } from "./SettingsRfcsSection.vue?vue&type=template&id=6b28ef0b&scoped=true"
import script from "./SettingsRfcsSection.vue?vue&type=script&lang=js"
export * from "./SettingsRfcsSection.vue?vue&type=script&lang=js"

import "./SettingsRfcsSection.vue?vue&type=style&index=0&id=6b28ef0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b28ef0b"]])

export default __exports__